export default __webpack_public_path__ + "02b80ba887110cdcd09fe1469a5d404c.png";